//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetchAll, pageExport } from '@/apis/receipt'
import moment from 'moment';
export default {
    data() {
        return {
            config: {
                //運動類型
                status: [

                ],
            },
            searchQuery: {
                barCode: "",
                itemCode: "",
                itemName: "",
            },
            //table loading
            loading: false,
            //table data
            records: [],
            //table columns
            columns: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
        this.columns = [
            { title: '生產批次', dataIndex: 'serial_no', key: 'serial_no', width: 200 },
            { title: '工單號', dataIndex: 'work_order_no', key: 'work_order_no', width: 200 },
            { title: 'ID', dataIndex: 'id', key: 'id', width: 200 },
            { title: 'BarCode', dataIndex: 'barcode', key: 'barcode', width: 200 },
            { title: '商品貨號', dataIndex: 'item_code', key: 'item_code', width: 200 },
            { title: '品名', dataIndex: 'item_name', key: 'item_name', width: 260 },
            { title: '允重上限', dataIndex: 'upper_limit', key: 'upper_limit', width: 150 },
            { title: '允重下限', dataIndex: 'lower_limit', key: 'lower_limit', width: 150 },
            { title: '每箱包裝數', dataIndex: 'unit_box', key: 'unit_box', width: 150 },
            { title: '不織布初始量', dataIndex: 'no_package_first_num', key: 'no_package_first_num', width: 150 },
            { title: '不織布剩餘量', dataIndex: 'no_package_remain_num', key: 'no_package_remain_num', width: 150 },
            { title: '不織布耗用', dataIndex: 'no_package_consume_num', key: 'no_package_consume_num', width: 150 },
            { title: '包裝袋初始量', dataIndex: 'package_first_num', key: 'package_first_num', width: 150 },
            { title: '包裝袋剩餘量', dataIndex: 'package_remain_num', key: 'package_remain_num', width: 150 },
            { title: '包裝袋耗用', dataIndex: 'package_consume_num', key: 'package_consume_num', width: 150 },
            { title: '標籤初始量', dataIndex: 'label_first_num', key: 'label_first_num', width: 150 },
            { title: '標籤剩餘量', dataIndex: 'label_remain_num', key: 'label_remain_num', width: 150 },
            { title: '標籤耗用', dataIndex: 'label_consume_num', key: 'label_consume_num', width: 150 },
            { title: '檢重包數', dataIndex: 'check_num', key: 'check_num', width: 150 },
            { title: 'NG數', dataIndex: 'check_ng_num', key: 'check_ng_num', width: 150 },
            { title: '通過包數', dataIndex: 'check_ok_num', key: 'check_ok_num', width: 150 },
            { title: '裝箱數', dataIndex: 'box_num', key: 'box_num', width: 150 },
            { title: '合格包數', dataIndex: 'ok_num', key: 'ok_num', width: 150 },
            { title: '末端損失包數', dataIndex: 'lose_num', key: 'lose_num', width: 150 },
            { title: '總損失包數', dataIndex: 'lose_total_num', key: 'lose_total_num', width: 150 },
            { title: '每包包裝袋耗用', dataIndex: 'expected_bag_unit', key: 'expected_bag_unit', width: 150 },
            { title: '每包標籤耗用', dataIndex: 'expected_label_unit', key: 'expected_label_unit', width: 150 },
            { title: '每包不織布耗用', dataIndex: 'expected_nonwoven_unit', key: 'expected_nonwoven_unit', width: 150 },
            { title: '不織布耗用優化率', dataIndex: 'expected_nonwoven_use_rate', key: 'expected_nonwoven_use_rate', width: 150 },
            { title: '包裝袋耗用優化率', dataIndex: 'expected_bag_use_rate', key: 'expected_bag_use_rate', width: 150 },
            { title: '標籤耗用優化率', dataIndex: 'expected_label_use_rate', key: 'expected_label_use_rate', width: 150 },

            // { title: '建立者', dataIndex: 'created_by', key: 'created_by', width: 150 },
            { title: '創建時間', dataIndex: 'created_at', key: 'created_at', width: 180, },
            { title: '操作', key: 'operation', width: 330, scopedSlots: { customRender: 'action' }, }
        ];
    },
    mounted() {
        this.$nextTick(async () => {
            await this.onPageLoad();
        });
    },
    methods: {
        toEdit(record) {
            this.$router.push(`/receipt/edit/${record.id}`);
        },
        onDelete(record) { },
        async onPageConfig() {
            try {

            } catch (error) {
                this.$message.error(error.message);
            }
        },
        async onPageLoad(isPostBack) {
            if (this.loading) return;
            if (!isPostBack) {
                this.pagination.current = 1;
            }
            try {
                this.loading = true;
                const res = await fetchAll({
                    ...this.searchQuery,
                    page: this.pagination.current,
                    pageSize: this.pagination.pageSize
                });
                this.records = res.data.records;
                this.pagination.total = res.data.total;
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        },


        //頁面事件
        handleTableChange(pagination, filters, sorter) {
            this.searchQuery.exp = 0;
            this.pagination.current = pagination.current;
            this.onPageLoad(true);
        },
        //搜尋表單提交
        handleSearchSubmit(e) {
            this.searchQuery.exp = 0;
            e.preventDefault();
            this.onPageLoad();
        },
        handleToAdd(id) {
            this.$router.push('/receipt/add');
        },
        handleToExport() {
            this.searchQuery.exp = 1;
            this.onPageExport();
        },
        async onPageExport() {
            try {
                this.loading = true;
                const response = await pageExport({
                    ...this.searchQuery
                });

                // 創建下載鏈接
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `product_item_${moment().format('MMDDss')}.xlsx`); // 設置文件名
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.loading = false;
            }
        }
    }
}
